import React, { useContext, useEffect, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import AppContext from "../../../../context/app-context";
import "./ProductAdvice.css";
import { formatDateToCustomString, formatDateToTime } from "../../../../utils";
import { fetchApi } from "../../../../api";
import Table from "../../../../components/table/Table";
import { TableHeaderItem } from "../../../../components/table/table.utils";

type Props = {
  onClickBack?: () => void;
  onNavigate?: (s: number, arg?: any) => void;
};

export const ProductAdvice = (props: Props) => {
  const { onClickBack, onNavigate } = props;

  const { setIsLoading, backendServer } = useContext(AppContext);

  const [estate, setEstate] = useState<any>();
  const [data, setData] = useState<any[]>([]);

  const getProductAdvice = async () => {
    try {
      const url = `${backendServer}/product-advice`
      setIsLoading?.(true);
      const {data, hasError} = await fetchApi({url, method: "GET"});
      data?.data && setData([...data?.data].reverse());

      console.log(data?.data[0])

      setIsLoading?.(false);
    } catch (error: any) {
      setIsLoading?.(false);
    }
  };

  useEffect(() => {
    getProductAdvice();
  }, []);

  const header: TableHeaderItem[] = [
    // { key: "externalProductId", label: "External ProductID" },
    // { key: "estateId", label: "Estate ID" },
    // { key: "vendorId", label: "Vendor ID" },
    // { key: "productType", label: "Product Type" },
    { key: "externalProductName", label: "Product Name" },
    { key: "externalProductPrice", label: "Price" },
    { key: "vendorCategory", label: "Vendor Category" },
    { key: "vendorName", label: "Vendor Name" },
    { key: "estateNames", label: "Estate Name (s)" },
    { key: "externalProductQuantity", label: "Quantity" },
    { key: "matchRating", label: "Rating" },
    { key: "createdAt", label: "Initiated On" },
    // { key: "suggestedInternalProductId", label: "ProductID" },
    { key: "treated", label: "Treated Status" },
  ];

  const filters = ["All", "Single Vendor"];
  

  return (
    <div>
      <div className="uh-container">
        <div className="financemgt-back-btn" onClick={() => onClickBack?.()}>
          <MdKeyboardArrowLeft size={25} />
          Back
          {/* <MdKeyboardArrowLeft size={25} />
          Back{" "} */}
        </div>
        <div className="estate-incentive-label">Product Advice - GPASS</div>
        {/* <div className="uh-card-wrapper">
          {filters.map((x, i) => (
            <div
              key={i}
              className={`uh-card ${filter === x ? "uh-card-active" : " "}`}
              style={{marginRight: "10px"}}
              onClick={() => {
                setFilter(x);
              }}
            >
              Filter by {x}
            </div>
          ))}
        </div> */}

        <Table
          showSearchBar
          sn
          data={data}
          header={header}
          onRowClick={(row) => {
            onNavigate?.(1, row)
          }}
          onRefreshIconClick={() => getProductAdvice()}
          pagination={{rowsPerPage: 100, totalDataCount: data?.length}}
          customTdWrappers={[
            {
              rowKeyName: "externalProductPrice",
              element: (val, row) => <div>NGN {(parseFloat(val)).toFixed(2)}</div>,
            },
            {
              rowKeyName: "matchRating",
              element: (val, row) => <div>{(parseFloat(val) * 100).toFixed(0)} %</div>,
            },
            {
              rowKeyName: "treated",
              element: (val, row) => <div style={{color: `${val}` === "false"? "tomato": "teal"}}>{`${val}` === "false"? "Not Treated": "Treated"}</div>,
            },
            {
              rowKeyName: "createdAt",
              element: (val, row) => <div>{formatDateToTime(new Date(val))}  on  {formatDateToCustomString(new Date(val))}</div>,
            },
            {
              rowKeyName: "estateNames",
              // element: (val, row) => <div>{val? `${val?.join(", ")}`: row?.estateName}</div>,
              element: (val, row) => <div >{val? val?.join(", "): row?.estateName}</div>,
            },
          ]}
        />
      </div>
    </div>
  );
};
